import { IAccordionHeaderProps } from '../types';
import { StyledHoverableAccordionHeader } from './style';

export const HoverableAccordionHeader = (props: IAccordionHeaderProps) => {
  return <StyledHoverableAccordionHeader {...props} />;
};
